import tw from 'twin.macro';

export const StyledHamburgerIcon = tw.span`z-40 absolute`;
